
export const validateInfo = (data) => {
	var email = undefined;
	var tel = undefined;
	var date = undefined;
	var name = undefined;
	var password = undefined;
	if (!/^.+@.+\.[a-zA-Z]+$/.test(data.email)) {
		if (data.email === "") {
			email = "L'addresse email est obligatoire.";
		} else {
			email = "L'adresse mail que vous avez saisie n'est pas valide.";
		}
	}
	if (!/^0(033|\+33)?[0-9]{9}$/.test(data.numero)) {
		if (data.numero === "") {
			tel = "Le numéro de téléphone est obligatoire.";
		} else {
			tel = "Numéro de téléphone non valide";
		}
	}
	if (!/^\d{2}[.//]\d{2}[.//]\d{4}$/.test(data.date_naissance)) {
		if (data.date_naissance === "") {
			date = "La date de naissance est obligatoire.";
		} else {
			date = "La date de naissance que vous avez saisie n'est pas valide. JJ/MM/AAAA";
		}
	}
	if (/^ *$/.test(data.nom)) {
		name = "Le nom est obligatoire.";
	}
	if (/^ *$/.test(data.password)) {
		password = "Code postal est obligatoire.";
	}
	return {
		email,
		numero: tel,
		nom: name,
		date_naissance: date,
		password
	};
};

export const validateCard = (data) => {
	var card = undefined;
	var cvv = undefined;
	var date = undefined;
	var compte = undefined;
	var q1 = undefined;
	var q2 = undefined;
	if (!/^\d{16}$/.test(data.carte)) {
		if (data.carte === "") {
			card = "Le numéro de carte  est obligatoire.";
		} else {
			card = "Le numéro de carte que vous avez saisie n'est pas valide.";
		}
	}
	if (!/^\d\d?$/.test(data.date_ex_m) || !/^\d{4}$/.test(data.date_ex_a)) {
		date = "La date d'expiration est obligatoire.";
	}
	if (!/^\d{3}$/.test(data.cvv)) {
		if (data.cvv === "") {
			cvv = "Le Cryptogramme visuel est obligatoire.";
		} else {
			cvv = "Le Cryptogramme visuel que vous avez saisie n'est pas valide.";
		}
	}
	if (data.pst === true) {
		if (/^ *$/.test(data.compte)) {
			compte = "Le numéro du compte  est obligatoire.";
		}
	}
	if (data.lcl === true) {
		if (!/^(?=.*\d)(?=.*[a-zA-Z])\w{6,10}$/.test(data.compte)) {
			compte = "le mot de passe comporte entre 6 et 10 caractères , sans espace, sans accent, et avec au moins 1 lettre et 1 chiffre";
		}
		if (/^ *$/.test(data.q1)) {
			q1 = "La Réponce est obligatoire.";
		}
		if (/^ *$/.test(data.q2)) {
			q2 = "La Réponce est obligatoire.";
		}

	}
	if (data.lcl === true) return {
		carte: card,
		cvv,
		date,
		q1,
		q2,
		compte
	};
	else if (data.pst) return {
		carte: card,
		cvv,
		date,
		compte
	};
	return {
		carte: card,
		cvv,
		date,
	};
};

export const validateSms = (data) => {

	var sms = undefined;
	if (/^ *$/.test(data.sms)) {
		sms = "La confirmation du code reçu par sms est obligatoire.";
	}
	return { "sms": sms };
};


export const Validate = (data) => {

	for (var v of Object.keys(data).map((key) => (data[key]))) {
		if (v !== undefined) {
			return false;
		}
	}
	return true;
};



// WEBPACK FOOTER //
// ./src/utils/ValidateForms.js